import React, { useEffect, useRef } from "react";
import "./cslider.css"
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import { ReactComponent as cl1SVG } from '../../images/cl1.svg'
import { ReactComponent as cl2SVG } from '../../images/cl2.svg'
import { ReactComponent as cl3SVG } from '../../images/cl3.svg'
import { ReactComponent as cl4SVG } from '../../images/cl4.svg'
import { ReactComponent as cl5SVG } from '../../images/cl5.svg'
import { ReactComponent as cl6SVG } from '../../images/cl6.svg'
import { ReactComponent as cl7SVG } from '../../images/cl7.svg'
import { ReactComponent as cl8SVG } from '../../images/cl8.svg'
import { ReactComponent as cl9SVG } from '../../images/cl9.svg'
import { ReactComponent as cl10SVG } from '../../images/cl10.svg'
import { ReactComponent as cl11SVG } from '../../images/cl11.svg'

const clientsdata = [
    {
        id: 0,
        name: "Caru",
        logo: cl1SVG,
    },
    {
        id: 1,
        name: "Humana",
        logo: cl2SVG,
    },
    {
        id: 2,
        name: "SnicSnac",
        logo: cl3SVG,
    },
    {
        id: 3,
        name: "Mcdonalds",
        logo: cl4SVG,
    },
    {
        id: 4,
        name: "Gagua",
        logo: cl5SVG,
    },
    {
        id: 5,
        name: "PictoryTale",
        logo: cl6SVG,
    },
    {
        id: 6,
        name: "Alliance",
        logo: cl7SVG,
    },
    {
        id: 7,
        name: "Mcdonalds",
        logo: cl8SVG,
    },
    {
        id: 8,
        name: "Gagua",
        logo: cl9SVG,
    },
    {
        id: 9,
        name: "PictoryTale",
        logo: cl10SVG,
    },
    {
        id: 10,
        name: "Alliance",
        logo: cl11SVG,
    }
]

const Cslider = () => {
    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, [])
    const sliderRef = useRef(null);

    useEffect(() => {
        const slider = sliderRef.current;

        const startScrolling = () => {
            if (slider) {
                const scrollWidth = slider.scrollWidth;
                const clientWidth = slider.clientWidth;

                let scrollLeft = 0;

                const scroll = () => {
                    scrollLeft += 1; // Adjust speed here
                    if (scrollLeft >= scrollWidth - clientWidth) {
                        scrollLeft = 0; // Reset for seamless looping
                    }
                    slider.scrollLeft = scrollLeft;
                };

                const interval = setInterval(scroll, 10); // Adjust interval for smooth scrolling
                return () => clearInterval(interval);
            }
        };

        return startScrolling();
    }, []);

    return (
        <div className='clslider-main' data-aos="fade-up" data-aos-duration="1000">

            <p className='clslider-title'>Our talented team has extensive experience working on projects for leading global brands.</p>
            <div className="clslider-wrapper" ref={sliderRef}>
                {[...clientsdata, ...clientsdata].map((client, id) => {
                    const LogoComponent = client.logo; 
                    return (
                        <div key={id}
                            className="cl-item ">
                            <LogoComponent /> 
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Cslider